import {
  Component,
  ViewChild,  
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FileDirectory } from '../../shared/models/file-directory';

@Component({
  selector: 'sp-select-folder-modal',
  templateUrl: './select-folder-modal.component.html',
  styleUrls: ['./select-folder-modal.component.scss'],
  standalone: false
})
export class SelectFolderModalComponent implements OnChanges, AfterViewInit {
  @ViewChild(ModalDirective, { static: true }) public bsModal: ModalDirective;

  @Input() folderStructure: FileDirectory;
  @Input() itemName: string;
  @Input() currentFolderId: string = null;
  @Input() excludeFolderIds: string[] = [];

  @Output() folderSelected: EventEmitter<string> = new EventEmitter<string>();

  selectedFolder: FileDirectory;

  ngAfterViewInit() {
    this.bsModal.config.keyboard = false;
    this.bsModal.config.ignoreBackdropClick = true;
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['folderStructure'] && this.folderStructure) {
      // this.folderStructure['isExpanded'] = true;
    }
  }

  collaspeFolders(folder: FileDirectory) {
    if (folder == null) { return; }
    folder['isExpanded'] = false;

    if (folder.folders == null || folder.folders.length === 0) { return; }

    folder.folders.forEach((f) => {
      this.collaspeFolders(f);
    });
  }

  show(): void {
    this.selectedFolder = null;
    this.collaspeFolders(this.folderStructure);
    this.folderStructure['isExpanded'] = true;  // expand top level by default
    this.bsModal.show();
  }

  close(): void {
    this.bsModal.hide();
  }

  isFolderExcluded(folder: FileDirectory) {
    return this.excludeFolderIds && this.excludeFolderIds.indexOf(folder.folderId) >= 0;
  }

  isSelectedFolder(folder: FileDirectory) {
    return this.selectedFolder && this.selectedFolder.folderId === folder.folderId;
  }

  toggleSelectedFolder(folder: FileDirectory) {
    if (this.isSelectedFolder(folder)) {
      this.selectedFolder = null;
    } else {
      this.selectedFolder = folder;
    }
  }

  toggleExpandFolder(folder: FileDirectory) {
    if  (folder && folder.folders && folder.folders.length > 0) {
      folder['isExpanded'] = ! folder['isExpanded'];
    }
  }

  onSelectFolderAndClose() {
    this.folderSelected.emit(this.selectedFolder.folderId);
    this.close();
  }

}
